import { render, staticRenderFns } from "./AccountVerification.vue?vue&type=template&id=8985c3fc&scoped=true&"
import script from "./AccountVerification.vue?vue&type=script&lang=js&"
export * from "./AccountVerification.vue?vue&type=script&lang=js&"
import style0 from "./AccountVerification.vue?vue&type=style&index=0&id=8985c3fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8985c3fc",
  null
  
)

export default component.exports